import { render } from "./layout-vertical-transparent.vue?vue&type=template&id=7836c020&scoped=true"
import script from "./layout-vertical-transparent.vue?vue&type=script&lang=js"
export * from "./layout-vertical-transparent.vue?vue&type=script&lang=js"

import "./layout-vertical-transparent.vue?vue&type=style&index=0&id=7836c020&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7836c020"]])

export default __exports__